import { createGlobalStyle } from 'styled-components';

import resets from './resets';
import resetsMemed from './resets-memed';
import icons from './icons';
import fontInfra from './font-infra';

export const GlobalStyles = createGlobalStyle`
  ${resets};
  ${fontInfra};
  ${resetsMemed};
  ${icons};
`;
